import {
  FormGroup,
  FormHelperText,
  TextField
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import {
  DistrictField,
  ProvinceField,
  SubDistrictField,
  useAddress,
  ZipcodeField
} from "components/ltr-request-document/components/Address";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function Workpermit({
  colSpan = 6,
  bagdeStart = 19,
  formik,
  prefixFieldName = "",
  disabled = false
}) {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName: "workpermit.ProvinceId",
    DistrictFieldName: "workpermit.DistrictId",
    SubDistrictFieldName: "workpermit.SubDistrictId",
    ZipcodeFieldName: "workpermit.Zipcode",
  });
  const accommodationConfig = get(masterData, "accommodationConfig", []);
  const vehicleConfigConfig = get(masterData, "vehicleConfig", []);
  const CountryConfig = get(masterData, "countryConfig", []);
  const VisaTypeConfig = get(masterData, "visaTypeConfig", []);
  const immPointConfig = get(masterData, "immPointConfig", []);

  const canEdit = useSelector(canEditForm);

  const index = 0;

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.flexRow}>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError("workpermit.accommodationID", formik)}
              >
                <InputLabel shrink={formik.values.workpermit.accommodationID && accommodationConfig.length}>Residence Type</InputLabel>
                <Select
                  label="Residence  Type"
                  name="workpermit.accommodationID"
                  value={formik.values.workpermit.accommodationID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={disabled || !canEdit}
                  nonce={formik.values.workpermit.accommodationID && accommodationConfig.length}
                >
                  {accommodationConfig.map((title) => (
                    <MenuItem
                      value={title.accommodationID}
                      key={title.accommodationID}
                    >
                      {title.accommodationName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError("workpermit.accommodationID", formik)}
                >
                  {getErrorMessage("workpermit.accommodationID", formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ width: 90 }}>Address</InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                placeholder="Address Name"
                name="workpermit.addressInThailand"
                value={formik.values.workpermit.addressInThailand}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <FormGroup style={{ marginTop: 16 }} row>
                <div className={classes.wrapField} style={{ flexDirection: 'row', marginRight: 16 }}>
                  <div className={classes.wrapField} style={{ marginRight: 8 }}>
                    <InputLabel>House Number</InputLabel>
                    <TextField
                      disabled={disabled || !canEdit}
                      variant="outlined"
                      className={classes.textField}
                      name="workpermit.houseNumber"
                      value={formik.values.workpermit.houseNumber}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="House Number"
                    />
                  </div>
                  <div className={classes.wrapField}>
                    <InputLabel>Soi</InputLabel>
                    <TextField
                      disabled={disabled || !canEdit}
                      variant="outlined"
                      className={classes.textField}
                      name="workpermit.soi"
                      value={formik.values.workpermit.soi}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Soi"
                    />
                  </div>
                </div>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <InputLabel>Road</InputLabel>
                  <TextField
                    disabled={disabled || !canEdit}
                    variant="outlined"
                    className={classes.textField}
                    placeholder="Road"
                    name="workpermit.road"
                    value={formik.values.workpermit.road}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div className={classes.wrapField}>
                  <ProvinceField {...addressFieldOptions} disabled={disabled} />
                </div>
              </FormGroup>
              <FormGroup style={{ marginTop: 16 }} row>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <DistrictField {...addressFieldOptions} disabled={disabled} />
                </div>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <SubDistrictField {...addressFieldOptions} disabled={disabled} />
                </div>
                <div className={classes.wrapField}>
                  <ZipcodeField {...addressFieldOptions} disabled={disabled} />
                </div>
              </FormGroup>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
